import React from "react";
import styles from "./Checkbox.module.scss";

type Props = {
  id: string;
  name: string;
  checkHandler: () => void;
  uncheckHandler: () => void;
  checked: boolean;
  input_class?: string;
  label_class?: string;
  text?: string;
};
const Checkbox: React.FC<Props> = ({
  id,
  name,
  checkHandler,
  uncheckHandler,
  checked,
  input_class,
  label_class,
  text,
}) => {
  const onChangeHander = () => {
    checked ? uncheckHandler() : checkHandler();
  };

  return (
    <div
      className={
        text?.length ? styles["checkbox-with-text"] : styles["checkbox"]
      }
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        onChange={onChangeHander}
        checked={checked}
        className={input_class}
      />
      {text && text.length ? (
        <label htmlFor={id} className={label_class}>
          <span>{text}</span>
        </label>
      ) : (
        <label htmlFor={id} className={label_class} />
      )}
    </div>
  );
};

export default Checkbox;
